<!--  Empty template for pagination control, since pagination will work only with collection and required pipe to be set.
To achieve this we are creating a blank template. Objective is to call the pipe -->
@for (item of inputObjectForPagination |  paginate: config; track trackItem($index, item)) {
}

<div nc-pagination-controls (pageChange)="pageChanged($event)" [config]="config"></div>